export default __webpack_public_path__ + "static/media/truck-black-icon.6453939d.svg";